/*
|-------------------------------------------------------------------------------
| 授信表单信息
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'
import { getCreditConfig } from '@/api/apply'

const creditConfigStore = defineStore({
  state: () => ({
    /**
     * 是否已经更新表单配置
     */
    hasUpdate: false,
    /**
     * 用户学历列表
     */
    education: [],
    /**
     * 银行列表
     */
    bank: [],
    /**
     * 银行卡类型列表
     */
    bankCardType: [],
    /**
     * 婚姻状况列表
     */
    marriage: [],
    /**
     * 紧急联系人关系列表
     */
    contactRelationship: [],
    /**
     * 用户学历列表
     */
    userCompanyIndustry: [],
    /**
     * 银行列表
     */
    userOccupation: [],
    /**
     * 银行卡类型列表
     */
    userMonthIncome: [],
    /**
     * 婚姻状况列表
     */
    userPayday: [],
  }),
  mutations: {
    update(state, data) {
      Object.assign(state, data)
    },
  },
  getters: {
    getOptions: (state) => (key: Exclude<keyof typeof state, 'hasUpdate'> ) => {
      const list = state[key] || []
      return list.map(({ name, code }) => {
        return {
          value: code,
          text: name,
        }
      })
    },
  },
  actions: {
    async getCreditConfig({
      state,
      rootState,
      commit,
    }: any) {
      // 如果已经拉取过就不重新拉取了
      if (state.hasUpdate) return
      let result: api_config_menu_credit.Response
      try {
        const res = await getCreditConfig()
        result = res.data
      } catch (err) {
        console.log('err: ', err); 
        return
      }
      commit('update', {
        hasUpdate: true,
        ...result
      })
    },
  },
})
export default creditConfigStore
export type ICreditConfigStoreState = IStoreState<
  typeof creditConfigStore.state
>
